// extracted by mini-css-extract-plugin
module.exports = {"dark":"in-app-notification-shell_dark__sOAgW"};